import { render, staticRenderFns } from "./NinthSection.vue?vue&type=template&id=8e508262&scoped=true&"
import script from "./NinthSection.vue?vue&type=script&lang=js&"
export * from "./NinthSection.vue?vue&type=script&lang=js&"
import style0 from "./NinthSection.vue?vue&type=style&index=0&id=8e508262&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e508262",
  null
  
)

export default component.exports